'use client';

import { Home } from '../display/';

export const Main = () => {
  return <Home />;
};
